<div class="enrollment-complete">
  @if (hasTimedOut()) {
    <h1 class="enrollment-complete__heading">Your application was submitted</h1>
    <p class="enrollment-complete__message">
      We are still setting up your account.
      @if (referenceId()) {
        You can try again now, or check your dashboard in a few minutes. If your
        {{ recordNoun }} still is not there, contact support and quote reference
        <strong>{{ referenceId() }}</strong>
      } @else {
        Try your dashboard in a few minutes. If your {{ recordNoun }} still is not there, contact
        support
      }
      so we can finish setting it up for you.
    </p>
    <div class="enrollment-complete__actions">
      @if (referenceId()) {
        <button
          class="enrollment-complete__action enrollment-complete__action--retry"
          type="button"
          [disabled]="isRetrying()"
          (click)="retryProvisioning()">
          @if (isRetrying()) {
            Trying again…
          } @else {
            Try again
          }
        </button>
      }
      <button class="enrollment-complete__action" type="button" (click)="goToDashboard()">
        Continue to my dashboard
      </button>
    </div>
  } @else {
    <h1 class="enrollment-complete__heading">Setting up your account</h1>
    <p class="enrollment-complete__message">
      Thank you for submitting your application. We are creating your {{ recordNoun }} record now —
      this usually takes a few seconds. You will be taken to your dashboard automatically.
    </p>
    <div class="enrollment-complete__spinner" role="status" aria-live="polite">
      <span class="sr-only">Setting up your account, please wait.</span>
    </div>
  }
</div>
